/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Phase_WriteInputs */



/**
* | output |
* | --- |
* | "Writing" |
*
* @param {Embed_Captions_Local_Phase_WriteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_phase_write = /** @type {((inputs?: Embed_Captions_Local_Phase_WriteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Phase_WriteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En écrivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scrivere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Письмо")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escribiendo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("写作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書き込み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिखना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escrita")
	return /** @type {LocalizedString} */ ("Writing")
});